<template>
  <div class="popup_wrap">
    <span @click="openDetailModal">
      <slot />
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="입장·체험료 할인, 면제대상 확인서">
      <div v-if="loaded">
        <div class="inputBox tableBox mb10">
          <table>
            <colgroup>
              <col width="140px" />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <td>
                  단체명
                  <br />
                  <small>(학교, 유치원 등)</small>
                </td>
                <td colspan="3">{{ orgName }}</td>
                <td>예약번호</td>
                <td colspan="3">{{ bundleRvNo }}</td>
              </tr>
              <tr>
                <td>주소</td>
                <td colspan="7">
                  <span class="adSchbox">
                    {{ orgPostCd }}
                    &nbsp;
                    {{ orgBasicAddress }}
                    &nbsp;
                    {{ orgEtcAddress }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  인솔자
                  <br />
                  <small>(예약자)</small>
                </td>
                <td colspan="3">
                  <span>{{ writerName }}</span>
                </td>
                <td>전화번호</td>
                <td colspan="3">
                  <span>{{ writerMobile || '(휴대전화)' }}</span>
                </td>
              </tr>
              <!-- <tr>
                <td rowspan="2">
                  인솔자
                  <br />
                  <small>(예약자)</small>
                </td>
                <td rowspan="2" colspan="3">
                  <span>{{ writerName }}</span>
                </td>
                <td rowspan="2">전화번호</td>
                <td colspan="3">
                  <span>{{ writerOrgPhone || '(근무처)' }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>{{ writerMobile || '(휴대전화)' }}</span>
                </td>
              </tr> -->
              <tr>
                <td rowspan="4">
                  할인(50%)대상
                  <br />
                  <small>(장애인, 국가유공자녀)</small>
                </td>
                <td rowspan="2">초등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td>4학년</td>
                <td>5학년</td>
                <td>6학년</td>
              </tr>
              <tr>
                <td>{{ dc_1 }}명</td>
                <td>{{ dc_2 }}명</td>
                <td>{{ dc_3 }}명</td>
                <td>{{ dc_4 }}명</td>
                <td>{{ dc_5 }}명</td>
                <td>{{ dc_6 }}명</td>
              </tr>
              <tr>
                <td rowspan="2">중·고등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td rowspan="2">
                  기타
                  <br />
                  <small>(유치원 등)</small>
                </td>
                <td rowspan="2" colspan="2">{{ dc_7 }}명</td>
              </tr>
              <tr>
                <td>{{ dc_8 }}명</td>
                <td>{{ dc_9 }}명</td>
                <td>{{ dc_10 }}명</td>
              </tr>
              <tr>
                <td rowspan="4">
                  면제(100%)대상
                  <br />
                  <small>(기초생활수급자녀)</small>
                </td>
                <td rowspan="2">초등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td>4학년</td>
                <td>5학년</td>
                <td>6학년</td>
              </tr>
              <tr>
                <td>{{ ex_1 }}명</td>
                <td>{{ ex_2 }}명</td>
                <td>{{ ex_3 }}명</td>
                <td>{{ ex_4 }}명</td>
                <td>{{ ex_5 }}명</td>
                <td>{{ ex_6 }}명</td>
              </tr>
              <tr>
                <td rowspan="2">중·고등학교</td>
                <td>1학년</td>
                <td>2학년</td>
                <td>3학년</td>
                <td rowspan="2">
                  기타
                  <br />
                  <small>(유치원 등)</small>
                </td>
                <td rowspan="2" colspan="2">{{ ex_7 }}명</td>
              </tr>
              <tr>
                <td>{{ ex_8 }}명</td>
                <td>{{ ex_9 }}명</td>
                <td>{{ ex_10 }}명</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="signbox mb50">
          <br />
          <p class="sign1">
            <span>{{ orgName }}</span>
            &nbsp;
            <span>인솔자</span>
            &nbsp;
            <span>{{ writerName }}</span>
          </p>
          <br />
          <p class="sign1">본인은 한국잡월드 입장·체험료 할인, 면제 대상자가</p>
          <p class="sign1">
            <b>[할인 총 {{ totDcPcnt }}명], [면제 총 {{ totExPcnt }}명]</b>
            임을 위와 같이 확인합니다.
          </p>
          <br />
          <p class="sign1">{{ d_year }}년 &nbsp;{{ d_month }}월 &nbsp;{{ d_day }}일</p>
          <br />
          <p class="sign3">한국잡월드 이사장 귀하</p>
        </div>
      </div>
      <template slot="footer">
        <div class="btn_wrap" style="justify-content: center">
          <a class="btn btn_bg color1 btn_popup" @click="onEditClick">수정</a>
          <a class="all-full btn btn_bg gray" @click="closeModal">닫기</a>
        </div>
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>
<script>
import api from '@/api/api_config';
import { mapActions } from 'vuex';
import { isLoggedIn, gfn_popup } from '@/utils/reserve';
import Modal from '@/components/common/Modal.vue';
import TabItem from '@/components/common/TabItem.vue';

export default {
  components: { Modal, TabItem },
  props: {
    bundleRvNo: {
      type: String,
      default: '',
    },
    openRvp: {
      type: Function,
    },
  },
  data() {
    return {
      modal: {
        open: false,
      },
      loaded: false,
      appointList: {},
      resultList: [],
    };
  },
  computed: {
    totExPcnt() {
      this.ex_tot = this.ex_1 + this.ex_2 + this.ex_3 + this.ex_4 + this.ex_5 + this.ex_6 + this.ex_7 + this.ex_8 + this.ex_9 + this.ex_10;
      return this.ex_tot;
    },
    totDcPcnt() {
      this.dc_tot = this.dc_1 + this.dc_2 + this.dc_3 + this.dc_4 + this.dc_5 + this.dc_6 + this.dc_7 + this.dc_8 + this.dc_9 + this.dc_10;
      return this.dc_tot;
    },
  },
  watch: {
    'modal.open': function (to) {
      if (to) {
        this.loadVerificationData();
      }
    },
  },
  methods: {
    ...mapActions('reserve', ['editReserveInfo']),
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    openDetailModal() {
      if (isLoggedIn()) {
        this.openModal();
      }
    },
    onEditClick() {
      this.closeModal();
      this.openRvp();
    },
    async loadVerificationData() {
      const param = {
        bundleRvNo: this.bundleRvNo,
      };
      let form = new FormData();
      for (let key in param) {
        form.append(key, param[key]);
      }
      try {
        const result = await api.post('/api/reservation/' + this.bundleRvNo + '/verification', form);
        if (result.data.success) {
          const response = result.data.response;
          let data = response.verification;
          if (data) {
            this.writerName = data.writer_name || data.user_name;
            this.writerOrgPhone = data.writer_org_phone;
            this.writerMobile = data.writer_mobile || data.user_mobile_num;
            this.orgName = data.ev_org_name || data.org_name;
            this.orgPostCd = data.org_post_cd || data.post_code;
            this.orgBasicAddress = data.org_basic_address || data.basic_address;
            this.orgEtcAddress = data.org_etc_address || data.etc_address;
            this.dc_1 = data.dc_1 || 0;
            this.dc_2 = data.dc_2 || 0;
            this.dc_3 = data.dc_3 || 0;
            this.dc_4 = data.dc_4 || 0;
            this.dc_5 = data.dc_5 || 0;
            this.dc_6 = data.dc_6 || 0;
            this.dc_7 = data.dc_7 || 0;
            this.dc_8 = data.dc_8 || 0;
            this.dc_9 = data.dc_9 || 0;
            this.dc_10 = data.dc_10 || 0;
            this.ex_1 = data.ex_1 || 0;
            this.ex_2 = data.ex_2 || 0;
            this.ex_3 = data.ex_3 || 0;
            this.ex_4 = data.ex_4 || 0;
            this.ex_5 = data.ex_5 || 0;
            this.ex_6 = data.ex_6 || 0;
            this.ex_7 = data.ex_7 || 0;
            this.ex_8 = data.ex_8 || 0;
            this.ex_9 = data.ex_9 || 0;
            this.ex_10 = data.ex_10 || 0;
            const today = new Date();
            this.d_year = data.reg_year || today.getFullYear();
            this.d_month = data.reg_month || today.getMonth() + 1;
            this.d_day = data.reg_day || today.getDate();
          }
          this.loaded = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
::v-deep .pop_layer {
  min-width: 1024px;
  left: calc(50% - 500px);
  margin-left: 0;
}
.pop_layer {
  & .tableBox {
    overflow: auto;
    text-align: center;
    border: inherit;
  }
  & input {
    width: 100%;
  }

  & .cnt-wrap {
    position: relative;
    display: inline-block;

    & input {
      width: 100%;
      padding-right: 1.5rem;
    }
  }
  & .cnt-wrap::after {
    content: '명';
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: grey;
    font-size: 14px;
  }

  & .signbox {
    & .sign1 {
      text-align: center;
    }
  }
}
@media all and (max-width: 1024px) {
  ::v-deep .pop_layer {
    min-width: 100%;
    left: 0;
  }
}
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
}
</style>
